import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import { headerSlice } from "./slices/headerSlice";
import { preferencesSlice } from "./slices/preferencesSlice";
import { filterReducer } from "../pages/search/api/filterReducer";
import { pagingationSlice } from "pages/latestResearch/publications/pagination/paginationSlice";
import { pubPreviewSlice } from "./slices/pubPreviewSlice";
import { searchBarSlice } from "./slices/searchBarSlice";
import { prefOptionsSlice } from "./slices/prefOptionsSlice";
import { miscSlice } from "./slices/miscSlice";
// Temporarily disable while migrating to JAPI
import { analystDirectorySlice } from "./slices/analystDirectorySlice";
import { analystDirectoryFilterSlice } from "./slices/analystDirectoryFilterSlice";
import { menuSlice } from "./slices/menuSlice";

const reducers = (history) =>
  combineReducers({
    header: headerSlice.reducer,
    preferences: preferencesSlice.reducer,
    prefOptions: prefOptionsSlice.reducer,
    filter: filterReducer.reducer,
    pagination: pagingationSlice.reducer,
    pubPreview: pubPreviewSlice.reducer,
    searchbar: searchBarSlice.reducer,
    misc: miscSlice.reducer,
    analystDirectory: analystDirectorySlice.reducer,
    analystDirectoryFilters: analystDirectoryFilterSlice.reducer,
    menu: menuSlice.reducer,
    router: connectRouter(history),
  });

export default reducers;
